import type { AccessoriesPricingResponse } from "../types/accessoriesPricing";

interface GetAccessoriesPricesRequest {
	configBundleId: string;
	targetProductIds: string[];
}

export async function getAccessoriesPrices(
	bundleId: string,
	targetProductIds: string[],
): Promise<AccessoriesPricingResponse> {
	const request: GetAccessoriesPricesRequest = {
		configBundleId: bundleId,
		targetProductIds,
	};

	const response = await fetch("/configure/price/getAccessoriesPrices", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(
			`Failed to fetch accessories prices: ${response.statusText}`,
		);
	}

	return response.json();
}
